module.exports = __webpack_public_path__ + "static/media/x-circle-red.3a643f55.svg";